import React from "react";
import { type IconProps, List, ListIcon, ListItem, type ListItemProps, type ListProps } from "@chakra-ui/react";
import { CheckIcon } from "ui/icons";

export function Checklist({ children, ...props }: ListProps) {
  return (
    <List variant="unstyled" spacing={4} {...props}>
      {children}
    </List>
  );
}

export type ChecklistItemProps = {
  checkColor?: IconProps["color"];
} & ListItemProps;

export function ChecklistItem({ checkColor, children, ...props }: ChecklistItemProps) {
  return (
    <ListItem display="flex" alignItems="start" gap={3} {...props}>
      <ListIcon as={CheckIcon} color={checkColor ?? "inherit"} boxSize="1.5em" mr={0} />
      {children}
    </ListItem>
  );
}
